export function areThirdPartyAppsEqual(workload1, workload2) {
    return (workload1.Text === workload2.Text &&
        workload1.Url === workload2.Url &&
        workload1.ThirdPartyIcon === workload2.ThirdPartyIcon &&
        workload1.Title === workload2.Title);
}
//# sourceMappingURL=areThirdPartyAppsEqual.js.map